<template>
  <div class="content">
    <!--  -->
    <el-row style="height:3vh;padding-left: 0.5vw;padding-top: 0.1vh;">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>劳务管理</el-breadcrumb-item>
            <el-breadcrumb-item>人员信息</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 30px);width:100%;position: relative;">
      <!-- 侧边树 -->
      <el-aside width="16%" style="height:100%" class="aside">
        <el-card style="height:100%;overflow: auto;">
          <el-tree
             :data="dataTree"
            ref="tree"
            :props="defaultProps"
            :expand-on-click-node="false"
            :highlight-current="true"
            @node-click="handleNodeClick"
            node-key="id"
            :current-node-key="currentNodekey"
            :default-expanded-keys="expandedkeys"
          >
            <span class="span-ellipsis" slot-scope="{ node, data }" style="width: 100%;text-align: left;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                <span :title="node.label" class="">{{data.name}}</span>
            </span>
          </el-tree>
        </el-card>
      </el-aside>
      <!-- 右边 -->
      <el-main class="build-CURD" style="height: 100%;padding:0px !important; padding-left: 20px !important; position: relative;width: 84%;">
        <el-card class="box-card box-card_right" style="height:100%;padding:0px !important">
          <!-- 搜索框上 -->
          <div style=" margin: 10px 20px;display:flex;align-items: center;height:60px" >
            <div>选择月份：</div>
            <el-date-picker type="month" placeholder="选择月份" v-model="search.month"  @change="doFilter" ></el-date-picker>
            <span style="margin-left:20px">人员检索：</span>
            <el-input placeholder="请输入姓名" v-model="search.name"></el-input>
            <el-button type="primary" icon="el-icon-search" @click="doFilter" style="margin-left:1vh;">查询</el-button>
          </div>
          <div class="build-table">
            <el-table :data="tableDataEnd" border height="100%" style="width: 100%;">
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <el-table-column label="序号" width="80" fixed>
                <template slot-scope="scope">
                  <span>{{ scope.row.index }}</span>
                </template>
              </el-table-column>
              <el-table-column label="姓名" fixed>
                <template slot-scope="scope">
                  <a>{{ scope.row.personName}}</a>
                </template>
              </el-table-column>
              <el-table-column label="班组" fixed width="150">
                <template slot-scope="scope">
                  <a :title="scope.row.teamsName">{{ scope.row.teamsName}}</a>
                </template>
              </el-table-column>
              <el-table-column :label="item" v-for="item in dateList" :key="item" width="200">
                <template slot-scope="scope">
                  <p class="tabP">
                    进场：
                    <span
                      v-if="scope.row[`workTime`+parseInt(item.split(`-`)[2])]!=-1"
                      style="color:#f1911a;"
                    >{{ scope.row['amDay'+parseInt(item.split("-")[2])] }}</span>
                  </p>
                  <p class="tabP">
                    出场：
                    <span
                      v-if="scope.row[`workTime`+parseInt(item.split(`-`)[2])]!=-1"
                      style="color:#f1911a;"
                    >{{ scope.row['pmDay'+parseInt(item.split("-")[2])] }}</span>
                  </p>
                  <p class="tabP">
                    时长：
                    <span
                      style="color:#f1911a;"
                      v-if="scope.row[`workTime`+parseInt(item.split(`-`)[2])]!=-1"
                    >{{ parseFloat(scope.row['workTime'+parseInt(item.split("-")[2])]).toFixed(2) }}</span>
                  </p>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页展示 -->
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10,20,50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import myHttp from '../../../untils/port.js'
import util from '../../../untils/util.js'
import base from '../../../untils/base'
export default {
  data() {
    return {
      tableDataEnd: [],
      search:{
        projectId:'',
        entId:'',
        teamsId:'',
        month: util.myTime.getCurMonth(), //所选下拉框数据
        name:'',
        minValue: '0',
        maxValue: '24',
      },
      date: '',
      dataText: '数据加载中...',
      dataTree: [], //树形列表
      defaultProps: {
        children: 'list',
        label: 'name'
      },
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      // attendVisible: false, //考勤机弹出框
      // attendData: [], //考勤设备列表
      // classVisible: false, //班组弹出框
      // classData: [], //班组数据
      // classId: '', //班组id
      // attendSel: [], //考勤机选择
      // personIdStr: '', //人员选择（下发）
      // ids: '', //人员信息id（班组配置）
      // personIdClass: '', //人员选择(班组配置)
      // dataText: '数据加载中...',
      // dialogTitle1:'配置结果',
      // statusper: [
      //   { label: '在职', value: '0' },
      //   { label: '离职', value: '1' }
      // ], //筛选人员状态
      // personStu: '0',
      // Phone: [],
      // currentPage: 1,
      // pageSize: 10,
      // totalItems: 0
      // modifyVisible: false,
      // imoportVisible:false,
      // workerInfo: {
      //   id: '',
      //   name: '',
      //   idcard: '',
      //   phone: '',
      //   idcard1: ''
      // },
      // typeNameAll: [], //考勤机类型字典表
      // workerType: [], //工种列表
      // managerType: [] ,//岗位列表
      // tableData1:[],
      currentNodekey: '', //默认选中的节点树
      expandedkeys: [], //默认展开的节点树
      dateList:[],
    }
  },
  mounted() {
    var port = util.session.get('roleId')
    this.getDateList()
    this.teamTree() //获取组织树
  },
  methods: {
    // 搜索数据
    doFilter(index) {
     
      let a = new Date(this.search.month.toString());
 let dataArry=[]
// a.setFullYear(2023); // 设置指定年份
// a.setMonth(0); // 设置指定月份
let days = new Date(a.getFullYear(), a.getMonth() + 1, 0).getDate(); // 获取本月一共有多少天  new Date()第3个参数默认为1，就是每个月的1号，把它设置为0时， new Date()会返回上一个月的最后一天，然后通过getDate()方法得到天数
for (let i = 1; i <= days; i++) {
  a.setDate(i) // 设置月份的日期
  let d = a.getDay(); // 获取星期几。 返回0 到 6星期日为 0、星期六为 6。
  if(d>=0&&d<7){
// 把拿到的指定月份的日期push到一个数组中然后赋值给原来的数组
    dataArry.push(a.toLocaleDateString().replace(/\//g,"-"))
 

  }    
}
this.dateList=dataArry
this.search.month=a.getFullYear() + '-' + (a.getMonth() + 1)
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    // 获取数据
    getData() {
      var that = this
      this.listData = []
      this.search.pageSize = this.pageSize
      this.search.pageNum = this.currentPage
      myHttp.findAllMonthAttendInfo(this.search).then(
        //myHttp.getStatisMonth(option).then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.pageInfo.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
            }
            that.tableDataEnd = list
            that.totalItems = resp.data.data.pageInfo.total || 0
            if (that.tableDataEnd.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            // that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },
    //获取当月时间
    getDateList() {
      var date = this.search.month + '-01'
      var allDay = util.myTime.getMonthDay(date)
      var list = []
      for (var i = 0; i < allDay; i++) {
        var str = this.search.month
        if (i < 9) {
          str = str + '-0' + (i + 1)
        } else {
          str = str + '-' + (i + 1)
        }
        list.push(str)
      }
      this.dateList = list
    },
    //获取统计数量
    // getNum() {
    //   var that = this
    //   myHttp.countTeamsPersonInfo({
    //       month: this.searchDate,
    //       projectId: this.projectId
    //   }).then(
    //     function(resp) {
    //       if (resp.data.code == '200') {
    //         that.allCount = resp.data.data
    //       }
    //     },
    //     function() {}
    //   )
    // },
    //获取数据名称
    getNameById(id, list) {
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (id == list[i].value) {
          result = list[i].label
        }
      }
      return result
    },
    //点击树形结构
    handleNodeClick(data,data1,data2) {
      if (data.level == '1') {
        this.search.projectId = ''
        this.search.teamsId = ''
        this.search.entId = ''
        this.$refs.tree.setCurrentKey(undefined)
      } else if (data.level == '2') {
        this.search.projectId = data.id
        this.search.entId = ''
        this.search.teamsId = ''
      } else if(data.level == '3'){
        this.search.projectId = data1.parent.data.id
        this.search.entId = ''
        this.search.teamsId = ''
        this.$refs.tree.setCurrentKey(data1.parent.data.id)
      }else if(data.level == '4'){
        this.search.projectId = data1.parent.parent.data.id
        this.search.entId = ''
        this.search.teamsId = data.id
      }
      if (data.status == '2') {
        this.search.personStatus = '2'
      } else {
        this.search.personStatus = this.personStu
      }
      if(this.search.projectId && ''!=this.search.projectId){
        this.getData()
      }
    },
    //获取树形结构
    teamTree() {
      var that = this
      myHttp.getPageListPro({
          entId: util.session.get('groupId'),
          levelType:4
      }).then(function(resp) {
        if (resp.data.code == '200') {
          var list = resp.data.data.entOfficeProjectMenu || []
          that.dataTree = list
          // that.search.projectId= list.length>0? list[0].id:''
          if (list.length > 0) {
            for(var i=0;i<list.length;i++){
              if(list[i].list.length>0 && that.search.projectId==''){
                that.search.projectId= that.dataTree[i].list[0].id
                that.currentNodekey = that.dataTree[i].list[0].id
                that.expandedkeys.push(that.dataTree[i].list[0].id)
                that.$nextTick(() => {
                  // treeBox 元素的ref   value 绑定的node-key
                  that.$refs.tree.setCurrentKey(that.currentNodekey)
                })
                that.search.projectId = that.currentNodekey
              }
            }
            
          }
          that.getData()
        }
      })
    },
    //树形-根据id获取项目
    getProIdById(id,index,list){
      var result = ''
      for(var i=0;i<list.length;i++){
        if(index>1){
          for(var j=0;j<list[i].list.length;j++){
            if(index==2){
              if(id==list[i].list[j].id){
                result
              }
            }
          }
        }
      }
    },
    
    

  }
}
</script>
<style>
  @import '../../../assets/css/common.css';
  .el-tree-node__content{
      height: 30px;
  }
  .el-tree-node__label{
    font-size: inherit;
  }
  .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #303133;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #303133;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #303133;
    }
</style>
<style scoped>
.el-table--border{
  border: none;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
}
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.build-table {
  height: calc(100% - 140px);
}
.cur{
  background: #ECF5FF !important;
  /* border: 1px solid   #409EFF !important ; */
  color:#409EFF !important  ;
}
/* .build-CURD>>>.el-card__body{
 height: 100%;
}  */
div >>> .el-dialog__header {
  padding: 20px 20px 10px;
  text-align: center !important;
}
div >>> .el-dialog__footer {
  padding: 10px 20px 20px;
  text-align: center;
  box-sizing: border-box;
}
.content >>> .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  color: #4d95fd;
  /* font-weight: bold; */
}
.tabP{
  text-align: left;
}
</style>